import {
    APPLE_QUERY_PARAM,
    OTP_PROOFKEY,
} from '@/lib/consts/auth';
import { LOGIN_QUERY_PARAMS, URL_PARAMS } from '@/lib/consts/params';

/**
 * Pre-auth / Game Portal handoff entry — show storefront loader background
 * and hide login chrome. Narrower than {@link isLoginAuthCallback}.
 * JWT checkout-link auto-login is included only when the dynamo JWT flag is on.
 */
export function isPreAuthLandingEntry(
    searchParams: URLSearchParams,
    checkoutJwtEnabled = false,
): boolean {
    if (searchParams.get(LOGIN_QUERY_PARAMS.REDIRECT_LOGIN_TOKEN)) {
        return true;
    }
    if (checkoutJwtEnabled && searchParams.get(URL_PARAMS.JWT_PARAM)) {
        return true;
    }
    return false;
}

/**
 * Auth callbacks / purge flows must still render /login even when a
 * session-token cookie is present (new login or stale-session cleanup).
 * Facebook returns via URL hash (`#access_token`), which the edge cannot
 * see — that path stays client-only.
 */
export function isLoginAuthCallback(searchParams: URLSearchParams): boolean {
    if (searchParams.get(LOGIN_QUERY_PARAMS.SESSION_EXPIRED) === 'true') {
        return true;
    }
    if (searchParams.get(LOGIN_QUERY_PARAMS.REDIRECT_LOGIN_TOKEN)) {
        return true;
    }
    if (searchParams.get(URL_PARAMS.JWT_PARAM)) {
        return true;
    }
    if (searchParams.get(APPLE_QUERY_PARAM) === 'true') {
        return true;
    }
    // `proofKey` alone is the mobile OTP callback: its token half lives in client
    // storage, which the edge cannot read. Requiring both here would 307 the
    // callback to /shop with the query stripped, leaving a returning player
    // signed in as whoever used the device last.
    if (searchParams.get(OTP_PROOFKEY)) {
        return true;
    }
    return false;
}
